module.exports = __webpack_public_path__ + "img/mind.286dc700.png";